function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 167.511,
  x2: 225.106,
  y1: 314.199,
  y2: 314.199
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cc8241"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#dea861"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 99.868,
  x2: 315.557,
  y1: 57.996,
  y2: 182.524
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#dea861"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebcba0"
}));

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 389.26,
  x2: 444.903,
  y1: 313.081,
  y2: 216.703
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ab2c37"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff7a85"
}));

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_4_",
  gradientTransform: "matrix(.866 -.5 0 1.155 295.454 1378.237)",
  gradientUnits: "userSpaceOnUse",
  x1: 57.542,
  x2: 283.558,
  y1: -857.855,
  y2: -857.855
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff4757"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff7a85"
}));

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 422.734,
  x2: 444.745,
  y1: 273.48,
  y2: 235.355
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c5baeb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d7d1eb"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m426.229 377.621v-261.224l-419.272 17.98v261.224c-.001 5.986 2.961 11.971 8.885 15.392l166.091 95.893c11.813 6.82 26.366 6.82 38.178 0l197.232-113.872c5.925-3.421 8.886-9.407 8.886-15.393z",
  fill: "url(#SVGID_1_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.843 118.987 197.231-113.872c11.812-6.82 26.366-6.82 38.178 0l166.091 95.893c11.847 6.84 11.847 23.94 0 30.78l-197.231 113.871c-11.813 6.82-26.366 6.82-38.178 0l-166.091-95.892c-11.848-6.84-11.848-23.94 0-30.78z",
  fill: "url(#SVGID_2_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m79.794 82.064 211.836 122.304 56.193-32.443-211.837-122.303z",
  fill: "#dea861"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#cc8241"
}, /*#__PURE__*/React.createElement("path", {
  d: "m113.379 62.657 211.836 122.304-11.007 6.355-211.836-122.304z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m291.63 204.368v46.406l56.193-32.443v-46.406z"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m480.592 174.602-31.479-18.175c-15.156-10.503-35.977-9.881-58.79 4.664-41.385 26.385-74.803 90.873-76.135 146.849-.579 24.35 4.826 43.514 14.351 56.173l-.014.021 50.949 65.147c.918 1.173 1.963 2.05 3.1 2.66l31.579 18.232z",
  fill: "url(#SVGID_3_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m505.043 237.174c0-60.458-37.781-87.337-83.581-58.138-41.385 26.384-74.803 90.873-76.135 146.849-.579 24.35 4.826 43.514 14.351 56.173l-.014.021 50.949 65.146c7.148 9.14 21.951.593 29.099-16.8l50.95-123.978-.014-.005c9.063-22.504 14.395-46.589 14.395-69.268z",
  fill: "url(#SVGID_4_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m483.484 222.479-23.499-13.528-.001.004c-9.276-4.916-21.192-4.215-34.192 3.29-29.578 17.077-53.556 62.892-53.556 102.33 0 21.682 7.257 36.903 18.699 43.393l-.008.018 21.471 12.396z",
  fill: "url(#SVGID_5_)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 447.806,
  cy: 296.327,
  fill: "#f2effa",
  rx: 82.219,
  ry: 46.515,
  transform: "matrix(.392 -.92 .92 .392 -.2 592.351)"
})));

var SvgPickup = function SvgPickup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPickup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pickup.1500bc1d.svg";
export { ForwardRef as ReactComponent };